export var registryFAQ = function() {
    var offset = ($('.desktopPage').length > 0) ? 86 : 0;
    $('#regFAQLink').on('click', function() {
        $('html, body').animate({
            scrollTop: $("#regFAQStart").offset().top - offset
        }, 500);
    });
};
